import { Component } from "react";
import { connect } from "react-redux";
import { authLogout } from "../../actions/authActions";
import { locationUpdate } from "../../actions/locationActions";
import { withRouter } from "react-router";
const qs = require("query-string");

class LocationWatch extends Component {
  componentDidMount() {
    this.checkLocation();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkLocation();
  }

  checkLocation = () => {
    const { pathname } = this.props.location;
    const params = qs.parse(this.props.location.search);
    this.props.locationUpdate({
      pathname,
      params
    });
  };

  render() {
    return false;
  }
}

export default withRouter(
  connect(
    null,
    { authLogout, locationUpdate }
  )(LocationWatch)
);
